import React from "react";

import "./index.css";

const ContinueBtn = ({onClick = () => {}, allow = false, value = "Continue"}) => {
  return <div
    className={`continue-btn ${!allow ? "continue-btn-disabled" : ""}`}
    onClick={() => {
      if (allow) {
        onClick();
      }
    }}
  >
    {value}
  </div>;
};

export default ContinueBtn;
